import { render, staticRenderFns } from "./TripRatingSettings.vue?vue&type=template&id=3ffcf956"
import script from "./TripRatingSettings.vue?vue&type=script&lang=js"
export * from "./TripRatingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports